export default "__VITE_ASSET__loGXRlV3__"